var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgDocumentsReuseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.156,
    height: 40.152,
    viewBox: "0 0 31.156 40.152"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-documents-reuse-white_svg__cls-2,.kpmg-documents-reuse-white_svg__cls-3{fill:none;stroke-width:1.6px;stroke:#fff;stroke-linecap:round}.kpmg-documents-reuse-white_svg__cls-3{stroke-linejoin:round;fill:#009ceb;stroke-width:1.1px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__ICN_Asociaza_Enabled",
    transform: "translate(-16.091 -15.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__ICN_Upload_file",
    "data-name": "ICN_Upload file",
    transform: "translate(16.891 16.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-reuse-white_svg__Path_823",
    d: "M8 0h13.557l8 8v22.552a8 8 0 01-8 8H8a8 8 0 01-8-8V8a8 8 0 018-8z",
    "data-name": "Path 823",
    strokeLinejoin: "round",
    stroke: "#fff",
    strokeLinecap: "round",
    fill: "none",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-reuse-white_svg__Path_822",
    d: "M0 .6v7.94",
    className: "kpmg-documents-reuse-white_svg__cls-2",
    "data-name": "Path 822",
    transform: "translate(20.998 -.304)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-reuse-white_svg__Line_62",
    d: "M0 0h7.999",
    className: "kpmg-documents-reuse-white_svg__cls-2",
    "data-name": "Line 62",
    transform: "translate(20.998 8.232)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__Group_701",
    "data-name": "Group 701",
    transform: "translate(32.539 40.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__Group_2557",
    "data-name": "Group 2557",
    transform: "translate(-347.539 -260.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__Group_979",
    "data-name": "Group 979",
    transform: "translate(336 247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-documents-reuse-white_svg__Group_2547",
    "data-name": "Group 2547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-reuse-white_svg__Path_847",
    d: "M362.767 250.647a3.462 3.462 0 00-5 0l-2.707 2.789a.31.31 0 000 .43.289.289 0 00.417 0l2.706-2.791a2.891 2.891 0 014.164 0 3.111 3.111 0 010 4.292l-3.539 3.648a2.889 2.889 0 01-4.165 0 .287.287 0 00-.416 0 .309.309 0 000 .428 3.462 3.462 0 005 0l3.54-3.649a3.731 3.731 0 000-5.149zm0 0",
    className: "kpmg-documents-reuse-white_svg__cls-3",
    "data-name": "Path 847",
    transform: "translate(-344.563 -246.933)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-documents-reuse-white_svg__Path_848",
    d: "M346.007 270.44l-2.321 2.312a2.977 2.977 0 01-4.219-4.2l3.375-3.362a3 3 0 014.219 0 .3.3 0 00.423-.421 3.594 3.594 0 00-5.064 0l-3.376 3.363a3.573 3.573 0 005.062 5.044l2.321-2.312a.3.3 0 10-.421-.421zm0 0",
    className: "kpmg-documents-reuse-white_svg__cls-3",
    "data-name": "Path 848",
    transform: "translate(.418 -7.745)"
  }))))));
}

export default SvgKpmgDocumentsReuseWhite;